define('lib/Podio.UI.AutoCompleter',['require','underscore','jquery','lib/jquery/jquery.bounds','lib/Podio.UI','lib/Podio.Event','lib/Podio.Utils.Text','signals','translate','jst!autocompleter/_item','jst!autocompleter/_loading','jst!autocompleter/_group'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  require('lib/jquery/jquery.bounds');
  var podioUI = require('lib/Podio.UI');
  var PodioEvent = require('lib/Podio.Event');
  var keyCodes = podioUI.KeyCodes;
  var utilsText = require('lib/Podio.Utils.Text');
  var signalsLib = require('signals');
  var t = require('translate');

  var jstItem = require('jst!autocompleter/_item');
  var jstLoading = require('jst!autocompleter/_loading');
  var jstGroup = require('jst!autocompleter/_group');

  var defaultOptions = {
    showItemIcon        : true,
    showContext         : true,
    selectFirstItem     : true,
    useAbsolutePosition : false,
    positionType        : 'absolute',
    widthOffset         : 0,
    topOffset           : -1, // For the borders
    useOuterBounds      : false,
    enableTabKey        : false,
    escapeInfo          : true,
    direction: 'bottom',
    classes : {
      autoCompleteItemActive : "active",
      item : "item",
      autocompleter : ''
    },
    text : {
      empty: t('We found nothing')
    }
  };

  var defaultTemplates = {
    wrapper       : _.template('<div class="podio-autocompleter"></div>'),
    list          : _.template('<ul class="hidden"></ul>'),
    item          : function(options) {
      return jstItem(options);
    },
    loading       : function(options) {
      return jstLoading(options);
    },
    group         : function(options) {
      return jstGroup(options);
    },
    image         : _.template('<img  src="<%= url %>" />'),
    icon          : _.template('<div class="<%= icon %>"></div>')
  };

  var utils = {
    highlightTerm : function (value, term) {
      if (!term) {
        return value;
      }

      return value.replace(new RegExp("(?![^&;]+;)(?!<[^<>]*)(" + utilsText.regexEscape(term) + ")(?![^<>]*>)(?![^&;]+;)", "gi"), "<b>$1</b>");
    }
  };

  var PodioAutoCompleter = function(elmContainer, options) {

    this.options = options ? $.extend(true, {}, defaultOptions, options) : defaultOptions;
    this.templates =  options.templates ? $.extend(true, {}, defaultTemplates, options.templates) : defaultTemplates;
    this.elmContainer = elmContainer;

    this.signals = {
      onItemSelected : new signalsLib.Signal(),
      onItemSecondaryActionClicked : new signalsLib.Signal(),
      onItemSecondaryActionHighlight : new signalsLib.Signal()
    };

    this.initialize.apply(this, arguments);
  };

  _.extend(PodioAutoCompleter.prototype, {

    initialize : function() {
      _.bindAll(this, 'onBoxKeyDown', 'onBoxKeyUp', 'onAutoCompleteItemMouseDown', 'onAutoCompleteItemClick', 'renderItem', 'updatePosition', 'dispatchSecondaryActionClick', 'onAutoCompleteSecondaryActionClick', 'getActiveItemElm');

      this.initElements();
      this.delegateEvents();
      this.updatePosition();
    },

    destroy : function() {
      this.elmAutocompleteList.undelegate('li.item', 'mousedown', this.onAutoCompleteItemMouseDown );
      this.elmAutocompleteList.undelegate('li.item', 'click', this.onAutoCompleteItemClick );
      this.elmAutocompleteList.undelegate('li.item .secondary-action', 'mousedown', this.onAutoCompleteSecondaryActionClick);
      this.elmContainer.unbind('keydown.autoCompleter', this.onBoxKeyDown);
      this.elmContainer.unbind('keyup.autoCompleter', this.onBoxKeyUp);
      this.elmWrapper.remove();
    },

    initElements : function(elmContainer) {
      if(!this.elmContainer) {
        throw 'No container element passed';
      }

      // Construct elements
      this.elmWrapper = $( this.templates.wrapper() );

      this.elmAutocompleteList = $( this.templates.list() );
      this.elmAutocompleteList.appendTo( this.elmWrapper );

      // Inject into DOM
      if(this.options.useAbsolutePosition) {
        this.elmWrapper.addClass( this.options.classes.autocompleter );
        this.elmWrapper.appendTo( 'body' );
      } else {
        this.elmWrapper.appendTo( this.elmContainer );
      }
    },

    delegateEvents : function() {
      this.elmAutocompleteList.delegate('li.item', 'mousedown', this.onAutoCompleteItemMouseDown );
      this.elmAutocompleteList.delegate('li.item', 'click', this.onAutoCompleteItemClick );
      this.elmAutocompleteList.delegate('li.item .secondary-action', 'mousedown', this.onAutoCompleteSecondaryActionClick);

      // Bind to container, since focus most likely is in a input element
      this.elmContainer.bind('keydown.autoCompleter', this.onBoxKeyDown);
      this.elmContainer.bind('keyup.autoCompleter', this.onBoxKeyUp);
    },

    updatePosition: function(scrollHeightBeforePopulation) {
      var bottomPosition;

      if (!scrollHeightBeforePopulation || !_.isNumber(scrollHeightBeforePopulation)) {
        scrollHeightBeforePopulation = document.documentElement.scrollHeight;
      }

      if (!this.elmContainer.length) {
        return;
      }

      if(!this.options.useAbsolutePosition) {
        return;
      }

      var bounds = this.elmContainer.bounds(this.options.useOuterBounds);
      var topPosition = this.options.positionType === 'fixed' ? this.elmContainer.position().top : bounds.top;

      this.elmWrapper.css({
        'position' : this.options.positionType,
        'zIndex'   : 1000,
        'left'     : bounds.left,
        'width'    : bounds.width + this.options.widthOffset
      });

      bottomPosition = window.innerHeight - topPosition + this.elmAutocompleteList.outerHeight();

      if (this.options.compensateForBottomMargin) {
        bottomPosition += scrollHeightBeforePopulation - window.innerHeight;
      }

      if (this.options.direction === 'top') {
        this.elmWrapper.css('bottom', bottomPosition);
      } else {
        this.elmWrapper.css('top', topPosition + bounds.height + this.options.topOffset);
      }

    },

    _selectItem : function(elmItem) {
      this.selectedItem = elmItem;

      elmItem.addClass( this.options.classes.autoCompleteItemActive );
      elmItem.siblings().removeClass( this.options.classes.autoCompleteItemActive );
    },

    _getItemData: function(itemId, groupId) {

      var itemsCollection = this.currentItemsCollections;

      if(groupId) {
        itemsCollection = (_.find(itemsCollection, function(group) {
          return group.id == groupId;
        })).items;
      }

      var itemData = _.find(itemsCollection, function(item) {
        return item.id == itemId;
      });

      return itemData;
    },

    onAutoCompleteItemClick: function(e) {
      e.preventDefault();
      e.stopPropagation();
      // Make sure we don't propagate the click event up the tree, so we don't trigger outsideclicks etc.

    },

    onAutoCompleteSecondaryActionClick: function(e) {
      e.preventDefault();
      e.stopPropagation();
      // Make sure we don't propagate the click event up the tree, so we don't trigger outsideclicks etc.

      var url = $(e.currentTarget).attr('href');
      this.dispatchSecondaryActionClick(url, e);
      return false;

    },

    dispatchSecondaryActionClick: function(url, e) {
      this.signals.onItemSecondaryActionClicked.dispatch(url, e);
    },

    onAutoCompleteItemMouseDown : function (e) {
      e.preventDefault();
      e.stopPropagation();

      var elmTarget = $(e.currentTarget);
      this.selectCurrentItem(elmTarget, e);

      return false;
    },

    selectCurrentItem: function(elmTarget, e){
      if (!elmTarget){
        elmTarget = this.selectedItem;
      }

      var itemId = String(elmTarget.data('id'));
      var groupId = String(elmTarget.data('group-id'));
      var itemData = this._getItemData(itemId, groupId);

      this.signals.onItemSelected.dispatch(itemData, elmTarget, e);
    },

    onBoxKeyUp: function(e) {
      if (e.keyCode === keyCodes.Shift) {
        this.signals.onItemSecondaryActionHighlight.dispatch(false, this.getActiveItemElm());
      }
    },

    onBoxKeyDown : function(e) {

      if ( !this.isVisible() ) {
        return true;
      }

      var elmActiveItem = this.elmAutocompleteList.find('.' + this.options.classes.item + '.' + this.options.classes.autoCompleteItemActive);

      switch(e.keyCode) {

        case keyCodes.Shift:
          this.signals.onItemSecondaryActionHighlight.dispatch(true, elmActiveItem);
          break;
        case keyCodes.DownArrow:
        case keyCodes.UpArrow:

          this.signals.onItemSecondaryActionHighlight.dispatch(false, this.getActiveItemElm());

          if (e.keyCode == keyCodes.DownArrow) {
            elmActiveItem = elmActiveItem.length ? elmActiveItem.nextAll('.' + this.options.classes.item).first() : this.elmAutocompleteList.find('.' + this.options.classes.item).first();
          } else {
            elmActiveItem = elmActiveItem.prevAll('.' + this.options.classes.item).first();
          }

          if (elmActiveItem.length) {
            this._selectItem(elmActiveItem);
          }

          return false;

        case keyCodes.Return:
          if (elmActiveItem.length) {
            if (e.shiftKey && elmActiveItem.find('.secondary-action').length) {
              var url = elmActiveItem.find('.secondary-action').attr('href');
              this.dispatchSecondaryActionClick(url, e);
            }
            else {
              this.selectCurrentItem(elmActiveItem, e);
            }
            return false;
          }
          return true;
        case keyCodes.Tab:
          if (elmActiveItem.length) {
            if(this.options.enableTabKey) {
              this.selectCurrentItem(elmActiveItem, e);
              return false;
            }
          }
          return true;
        case keyCodes.Esc:
          this.hide();
          return false;
      }
    },

    renderLoading : function() {
      this.elmAutocompleteList.empty();
      this.elmAutocompleteList.append( this.templates.loading() );

      this.show();
    },

    renderList : function(items, termToHighlight) {
      var self = this;

      return _.compact(_.map(items, function(item, index) {

        if(item.type == 'group'){
          return self.renderGroup(item, index, termToHighlight);
        } else {
          return self.renderItem(item, index, termToHighlight);
        }

      }));
    },

    renderGroup : function(group, index, termToHighlight) {
      var groupIndex = index;

      if(!group.items.length) {
        return null;
      }

      var elmTemp = $('<div />');
      var self = this;

      var elmGroupItem = $( this.templates.group({
        'id'    : _.escape(group.id),
        'name'  : _.escape(group.name),
        'icon'  : group.contextIcon
      }));

      elmGroupItem.appendTo(elmTemp);

      var elmRenderedItems = _.map(group.items, function(item, index) {
        return self.renderItem(item, index, termToHighlight, group.id, groupIndex);
      });

      elmTemp.append.apply( elmTemp, elmRenderedItems);

      return elmTemp.html();
    },

    renderIcon : function(data) {
      var html;

      if (data.indexOf('/') > -1 ) { // Not a valid CSS class with / => image
        html = this.templates.image({ url : data });
      } else {
        html = this.templates.icon({ icon : data });
      }

      return html;
    },

    renderItem : function(item, index, termToHighlight, groupId, groupIndex) {
      var htmlItemIcon, htmlContextIcon, className = null;

      if ( this.options.showItemIcon && (item.itemIcon || item.icon) )  {
        htmlItemIcon = this.renderIcon( item.itemIcon || item.icon );
      }

      if ( this.options.showContext && (item.contextIcon || item.contextContent) ) {
        htmlContextIcon = item.contextContent || this.renderIcon(item.contextIcon);
      }

      var info = item.info;
      if (info && this.options.escapeInfo) {
        info = _.escape(info);
      }

      if (item.className) {
        className = item.className;
      } else if (item.type) {
        className = item.type;
      }

      var elmListItem = $( this.templates.item({
        'id'                 : _.escape(item.id),
        'info'               : info,
        'value'              : utils.highlightTerm( _.escape(item.name) , termToHighlight ),
        'groupId'            : groupId ? _.escape(groupId) : null,
        'contextIcon'        : htmlContextIcon,
        'itemIcon'           : htmlItemIcon,
        'suffix'             : item.suffix ? _.escape(item.suffix) : null,
        'className'          : className,
        'secondaryAction'    : (item.secondaryAction && item.secondaryAction.url) ? item.secondaryAction : null,
        'presenceState': item.presence_state ? item.presence_state : null
      }));

      if (this.options.selectFirstItem && index === 0 && (_.isUndefined(groupIndex) || groupIndex === 0)) {
        this._selectItem(elmListItem);
      }

      return elmListItem;
    },

    selectItem : function(elmItemOrIndex) {

      var elmItem = _.isNumber(elmItemOrIndex) ? this.elmAutocompleteList.find('.' + this.options.classes.item).eq(elmItemOrIndex) : elmItemOrIndex;

      this._selectItem(elmItem);
    },

    renderEmpty: function() {
      this.elmAutocompleteList.empty();
      this.elmAutocompleteList.addClass('empty');
    },

    populate : function(itemsCollection, termToHighlight) {

      this.currentItemsCollections = itemsCollection;

      var elmTemp = $('<div />');
      var elmRenderedItems = this.renderList(itemsCollection, termToHighlight);

      if(!elmRenderedItems.length) {
        this.renderEmpty();
        return;
      }

      elmTemp.append.apply( elmTemp, elmRenderedItems);

      this.elmAutocompleteList.addClass('hidden').html(elmTemp.html());
      this.elmAutocompleteList.removeClass('empty');

      this.show();
    },

    show: function() {
      var self = this;

      var scrollHeightBeforePopulation = document.documentElement.scrollHeight;

      this.updatePosition(scrollHeightBeforePopulation);

      this.elmAutocompleteList.removeClass('hidden');

      if(this.options.useAbsolutePosition) {
        PodioEvent.bind('scroll', this.updatePosition, this);
        PodioEvent.bind('resize', this.updatePosition, this);
      }
    },

    hide : function() {
      var self = this;

      this.elmAutocompleteList.addClass('hidden');
      this.currentItemsCollections = null;

      if (this.options.useAbsolutePosition) {
        PodioEvent.unbind(undefined, undefined, this);
      }
    },

    isVisible : function() {
      return this.elmAutocompleteList.is(':visible');
    },

    getActiveItemData : function() {
      var elmActiveItem = this.elmAutocompleteList.find('.' + this.options.classes.item + '.' + this.options.classes.autoCompleteItemActive);

      if(!elmActiveItem.length) {
        return null;
      }

      var itemId = String(elmActiveItem.data('id'));
      var groupId = String(elmActiveItem.data('group-id'));

      var itemData = this._getItemData(itemId, groupId);

      return itemData;
    },

    getActiveItemElm: function() {
      return this.elmAutocompleteList.find('.' + this.options.classes.item + '.' + this.options.classes.autoCompleteItemActive);
    }
  });

  return PodioAutoCompleter;

});

